import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {GlobalModule} from "../global/global.module";
import { EndorseNameAppNoResultRoutingModule } from './endorse-name-app-no-result-routing.module';
import { EndorseNameAppNoResultComponent } from './endorse-name-app-no-result.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    EndorseNameAppNoResultRoutingModule,
    GlobalModule,
  ],
  declarations: [
    EndorseNameAppNoResultComponent
  ],
  providers: [
    DatePipe
  ]
})
export class EndorseNameAppNoResultModule {
}
